import * as C from './../containers/user/constants';

const InitialState = {
    data: {}
};


export default (state = InitialState, action) => {
    if (action.type && C[action.type]) {
        return {
            state: action.type,
            data: action.data || {}
        };

    }
    return state;
}


// WEBPACK FOOTER //
// ./src/store/user.reducer.js